import MarketingPagesView from "@/react/components/entityViews/marketingPages/MarketingPagesView";

export const MarketingPagesPage = () => {
  return (
    <div className="relative flex flex-1 flex-col bg-background w-full min-w-0 min-h-0" id="marketing-pages-page">
      <div className="flex-1 min-h-0">
        <MarketingPagesView />
      </div>
    </div>
  );
};

export default MarketingPagesPage;
